define(["require", "exports", "tslib", "vue"], function (require, exports, tslib_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DirectiveElDraggableDialog = void 0;
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    var DirectiveElDraggableDialog = (function (_super) {
        (0, tslib_1.__extends)(DirectiveElDraggableDialog, _super);
        function DirectiveElDraggableDialog() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DirectiveElDraggableDialog.prototype.bind = function (el, binding, vnode) {
            var dragDom = el.querySelector('.el-dialog');
            var dialogHeaderEl = el.querySelector('.el-dialog__header');
            dragDom.style.cssText += ';top:0px;';
            dialogHeaderEl.style.cssText += ';cursor:move;';
            dialogHeaderEl.onmousedown = function (e) {
                var disX = e.clientX - dialogHeaderEl.offsetLeft;
                var disY = e.clientY - dialogHeaderEl.offsetTop;
                var dragDomWidth = dragDom.offsetWidth;
                var dragDomHeight = dragDom.offsetHeight;
                var screenWidth = document.body.clientWidth;
                var screenHeight = document.body.clientHeight;
                var minDragDomLeft = dragDom.offsetLeft;
                var maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
                var minDragDomTop = dragDom.offsetTop;
                var maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;
                var styleLeftStr = getComputedStyle(dragDom).left;
                var styleTopStr = getComputedStyle(dragDom).top;
                if (!styleLeftStr || !styleTopStr)
                    return;
                var styleLeft;
                var styleTop;
                if (styleLeftStr.includes('%')) {
                    styleLeft = +document.body.clientWidth * (+styleLeftStr.replace(/%/g, '') / 100);
                    styleTop = +document.body.clientHeight * (+styleTopStr.replace(/%/g, '') / 100);
                }
                else {
                    styleLeft = +styleLeftStr.replace(/px/g, '');
                    styleTop = +styleTopStr.replace(/px/g, '');
                }
                document.onmousemove = function (e) {
                    var left = e.clientX - disX;
                    var top = e.clientY - disY;
                    if (-left > minDragDomLeft) {
                        left = -minDragDomLeft;
                    }
                    else if (left > maxDragDomLeft) {
                        left = maxDragDomLeft;
                    }
                    if (-top > minDragDomTop) {
                        top = -minDragDomTop;
                    }
                    else if (top > maxDragDomTop) {
                        top = maxDragDomTop;
                    }
                    var leftValue = left + styleLeft;
                    dragDom.style.cssText += ";left:".concat(leftValue, "px;top:").concat(Number(top) + Number(styleTop), "px;");
                    if (vnode.componentInstance) {
                        vnode.componentInstance.$emit('on-dialog-drag');
                    }
                    else if (vnode.elm) {
                        vnode.elm.dispatchEvent(new CustomEvent('on-dialog-drag'));
                    }
                };
                document.onmouseup = function () {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            };
        };
        return DirectiveElDraggableDialog;
    }(vue_1.default));
    exports.DirectiveElDraggableDialog = DirectiveElDraggableDialog;
});
//# sourceMappingURL=DirectiveElDraggableDialog.js.map